import { Card } from '@/components/ui/card.tsx'
import { PPVSalesRatioChart } from '@/modules/tracking/new-subscriber-analysis/ui/charts/ppv-sales-ratio-chart.tsx'

interface Props {
  total: number
  numberOfFanWhoBoughtPPV: number
  isFetching: boolean
}
export const PurchasingBehaviour = ({
  total,
  numberOfFanWhoBoughtPPV,
  isFetching,
}: Props) => {
  if (isFetching) {
    return (
      <div className="grid w-full animate-pulse gap-4 rounded-md bg-skeleton sm:h-72" />
    )
  }

  return (
    <Card className="grid gap-4 px-8 py-6 ">
      <div className="text-xl font-semibold leading-none">
        Pay-Per-View Sales-Ratio
      </div>
      <PPVSalesRatioChart
        total={total}
        subscribersWhoBought={numberOfFanWhoBoughtPPV}
      />
    </Card>
  )
}
